import { MeasureValues, useModelService } from 'services/model/model.service';
import { MeasureBreakdownList, MeasureBreakdownRow } from 'components/profitability/MeasureBreakdownList';

interface LogisticsCostsListProps {
  values?: MeasureValues;
  compareValues?: MeasureValues;
  isComparisonActive: boolean;
}

export function LogisticsCostsList({
  values = undefined,
  compareValues = undefined,
  isComparisonActive,
}: LogisticsCostsListProps) {
  const { getMeasures, getMeasuresByMetrics } = useModelService();
  const [itemOrderShpCst, itemOrderHdlCst, itemReturnShpCst, itemReturnHdlCst] = getMeasures([
    'itemSlsShpCostValOD',
    'itemSlsHdlCostValOD',
    'itemRetShpCostValExtExpOD',
    'itemRetHdlCostValExtExpOD',
  ]);
  const [orderShpCst, orderShpCstRate, orderHdlCst, orderHdlCstRate] = getMeasuresByMetrics(
    ['slsShpCstVal', 'slsShpCstRate', 'slsHdlCstVal', 'slsHdlCstRate'],
    'OD'
  );
  const [returnShpCst, returnShpCstRate, returnHdlCst, returnHdlCstRate, logCstVal, logCstRate] = getMeasures([
    'retShpCstValExtExpOD',
    'retShpCstRateExtExpOD',
    'retHdlCstValExtExpOD',
    'retHdlCstRateExtExpOD',
    'netSlsLogCostValExtExpOD',
    'netSlsLogCostRateExtExpOD',
  ]);

  const rows: MeasureBreakdownRow[] = [
    {
      labelMeasure: orderShpCst,
      perItemMeasure: itemOrderShpCst,
      totalMeasure: orderShpCst,
      shareMeasure: orderShpCstRate,
    },
    {
      labelMeasure: returnShpCst,
      perItemMeasure: itemReturnShpCst,
      totalMeasure: returnShpCst,
      shareMeasure: returnShpCstRate,
    },
    {
      labelMeasure: orderHdlCst,
      perItemMeasure: itemOrderHdlCst,
      totalMeasure: orderHdlCst,
      shareMeasure: orderHdlCstRate,
    },
    {
      labelMeasure: returnHdlCst,
      perItemMeasure: itemReturnHdlCst,
      totalMeasure: returnHdlCst,
      shareMeasure: returnHdlCstRate,
    },
    {
      labelMeasure: logCstVal,
      totalMeasure: logCstVal,
      shareMeasure: logCstRate,
      isTotal: true,
    },
  ];

  return (
    <MeasureBreakdownList
      titleMeasure={logCstVal}
      rows={rows}
      values={values}
      compareValues={compareValues}
      isComparisonActive={isComparisonActive}
      testId="profitability-logistics-costs-list"
    />
  );
}
